import $ from 'jquery';
import { getAxiosClient } from '~src/api';
import { changeImageSrc } from '~src/utils';
import { onErrorShowMessage } from '~src/errors';
import { getState, modifyState } from '~src/state';
import { trackEvent } from '~src/tracking';
import { FEATURES, isFeatureEnabled } from '~src/features';
import { fabric } from 'fabric';
import { createBoundaryRect } from '~core/expand';
import { prepareImageForEditing } from '~core/image';
import {
  startAiLoader,
  stopAiLoader,
  showAiSuccessMessage,
  sleep,
  AI_FEATURE_LOADING_MESSAGES,
} from '~core/aiLoader';

export default async function execExpand() {
  const allowUseExpand = await isFeatureEnabled(FEATURES.AI_USE_EXPAND, false);
  if (!allowUseExpand) {
    alert('Questa funzione non è disponibile nel tuo piano di abbonamento');
    return;
  }

  const selection = window.expandDrawingCanvas
    .getObjects()
    .find((obj) => obj.id === 'expanded-image');

  const imageUrl = await prepareImageForEditing(selection, false);

  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    return;
  }

  modifyState('expandRawImage', imageUrl);

  const startTime = performance.now();

  startAiLoader(AI_FEATURE_LOADING_MESSAGES.EXPAND, '✨ Espandi Scena');

  const expandCoordinates = getState('expandCoordinates');

  const size = {
    w: expandCoordinates.newSize[0],
    h: expandCoordinates.newSize[1],
  };

  const data = {
    imageUrl,
    imageSize: expandCoordinates.originalSize,
    newImageSize: expandCoordinates.newSize,
    imageLocation: expandCoordinates.imagePosition,
  };

  let queueResponse;
  let response;

  const maxAttempts = 100;
  const httpClient = await getAxiosClient();
  const httpClientWithRetries = await getAxiosClient(true, maxAttempts);

  try {
    queueResponse = await httpClient.post(
      `${process.env.GIOTTO_API_URL}/expand`,
      data
    );
  } catch (err) {
    console.error(err);
    stopAiLoader();
    return onErrorShowMessage();
  }

  await sleep(10000);

  try {
    response = await httpClientWithRetries.get(
      `${process.env.GIOTTO_API_URL}/expand?requestId=${queueResponse.data.requestId}`,
      data
    );
  } catch (err) {
    console.error(err);
    stopAiLoader();
    return onErrorShowMessage();
  }

  fabric.Image.fromURL(
    response.data.imageUrl,
    (img) => {
      window.expandDrawingCanvas.remove(selection);

      img.set({
        selectable: false,
        evented: false,
        crossOrigin: 'anonymous',
        id: 'expanded-image',
      });

      window.expandDrawingCanvas.add(img);
      window.expandDrawingCanvas.centerObject(img);

      const prevBoundaryRect = window.expandDrawingCanvas
        .getObjects()
        .find((obj) => obj.id === 'boundary-rect');
      if (prevBoundaryRect) {
        window.expandDrawingCanvas.remove(prevBoundaryRect);
      }

      window.expandDrawingCanvas.width = size.w + size.w * 0.5;
      window.expandDrawingCanvas.height = size.h + size.h * 0.5;

      const boundaryRect = createBoundaryRect(window.expandDrawingCanvas, img);
      window.expandDrawingCanvas.add(boundaryRect);
      window.expandDrawingCanvas.setActiveObject(boundaryRect);
      window.expandDrawingCanvas.renderAll();

      modifyState('expandCoordinates', {
        originalSize: [img.width * img.scaleX, img.height * img.scaleY],
        newSize: [img.width * img.scaleX, img.height * img.scaleY],
        imagePosition: [0, 0],
      });
    },
    { crossOrigin: 'anonymous' }
  );

  let magicFrame = selection._magicFrame;
  if (selection.type === 'MagicFrame') {
    magicFrame = selection;
  }

  if (magicFrame) {
    await magicFrame.updatePerson(response.data.imageUrl);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
    magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
  } else {
    const currentProps = {
      scaleX: selection.scaleX,
      scaleY: selection.scaleY,
      top: selection.top,
      left: selection.left,
    };

    await changeImageSrc(selection, response.data.imageUrl);

    selection.set({
      ...currentProps,
    });
  }

  $('#editor-menu-exec-ai-expand').prop('disabled', true);
  $('#editor-menu-apply-ai-expand').prop('disabled', false);

  stopAiLoader();

  showAiSuccessMessage(
    'Espandi Scena',
    'La scena è stata espansa con successo!'
  );

  trackEvent('AI Expand', {
    success: true,
    time_taken: parseInt(performance.now() - startTime, 10),
  });
}
